import src from "IMAGE";
export default { src, width: 4080, height: 2568, blurWidth: 0, blurHeight: 0};
